import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-text-four-decimal-number-renderer',
  templateUrl: './text-four-decimal-number-renderer.component.html',
  standalone: false
})
export class TextFourDecimalNumberRendererComponent implements ICellRendererAngularComp {
  errReq: boolean = false;
  value: string;
  params: ICellRendererParams;
  isVisible: boolean = false;
  placeholdertext: string = this.translate.instant('enter_amount_set_limit');

  constructor(private translate: TranslateService) { }

  initilize(params: ICellRendererParams) {
    if (params.data) {
      this.params = params;
      if (Number(params.data.allowanceRate) > 0)
        this.value = params.data.allowanceRate;

      if (Number(this.value) > 0)
        this.placeholdertext = '';

      this.errReq = (this.value == '' || Number(this.value) <= 0) || params.data.errorRecord ? true : false;
      if (this.errReq) {
        this.placeholdertext = this.translate.instant('label_Required');
        this.value = '';
      }
    }
  }

  agInit(params: any): void {
    this.params = params;
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.params = params;
    this.initilize(params);
    return true;
  }

  // Fires on every keystroke: persists the edit to the row data immediately (so it does not
  // revert on blur) and notifies the parent so the Save button lights up instantly while typing.
  onInput(event) {
    const raw = event.target.value;
    this.value = raw;
    this.errReq = (raw === '' || Number(raw) <= 0) ? true : false;
    if (this.params && this.params.data) {
      this.params.data.allowanceRate = raw;
      const onValueChange = (this.params as any).onValueChange;
      if (onValueChange) {
        onValueChange(this.params.data);
      }
    }
    this.commitValue();
  }

  onChange(event) {
    if (event.target.value && event.target.value != '') {
      this.value = parseFloat(event.target.value).toFixed(4);
    } else {
      this.value = event.target.value;
    }
    this.errReq = (this.value == '' || Number(this.value) <= 0) ? true : false;
    this.commitValue();
    if (this.params && this.params.data) {
      // Persist the formatted value onto the row data so a grid refresh keeps the edit
      // instead of reverting to the original value.
      this.params.data.allowanceRate = this.value;
    }
    this.params.setValue(this.value);
    this.params.node.setData(this.params.data);
    const onValueChange = (this.params as any).onValueChange;
    if (onValueChange) {
      onValueChange(this.params.data);
    }
    this.params.eGridCell.click();
  }
  private commitValue() {
    if (this.params.data) {
      this.params.data.allowanceRate = this.value;
    }
    const onChange = (this.params as any).onChange;
    if (onChange instanceof Function) {
      onChange(this.params);
    }
  }
}
